import { useEffect, useState, useCallback } from 'react';
import { apiClient } from '../../lib/api';
import { Tag } from '../../lib/types';

interface TagSelectorProps {
  selectedTags: number[];
  onTagsChange: (tags: number[]) => void;
  showDeleteButton?: boolean;
  onDeleteTag?: (id: number) => void;
}

export const TagSelector = ({
  selectedTags,
  onTagsChange,
  showDeleteButton = false,
  onDeleteTag
}: TagSelectorProps) => {
  const [tags, setTags] = useState<Tag[]>([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const fetchTags = useCallback(async () => {
    try {
      const data = await apiClient.get('/tags') as Tag[];
      setTags(data);
    } catch (err: any) {
      console.error('タグの取得に失敗しました:', err);
    }
  }, []);

  useEffect(() => {
    fetchTags();
  }, [fetchTags, refreshTrigger]);

  const toggleTag = (tagId: number) => {
    const newSelectedTags = selectedTags.includes(tagId)
      ? selectedTags.filter(id => id !== tagId)
      : [...selectedTags, tagId];
    onTagsChange(newSelectedTags);
  };

  const handleDelete = async (id: number) => {
    if (onDeleteTag) {
      await onDeleteTag(id);
      setRefreshTrigger(prev => prev + 1);
    }
  };

  return (
    <div className="flex flex-wrap gap-2">
      {tags.map((tag) => (
        <div
          key={tag.id}
          className={`
            flex items-center
            px-3 py-1 rounded-full
            ${selectedTags.includes(tag.id)
              ? 'bg-blue-500 text-white'
              : 'bg-gray-200 text-gray-700'
            }
            ${showDeleteButton ? 'pr-1' : ''}
          `}
        >
          <button
            type="button"
            onClick={() => toggleTag(tag.id)}
            className="text-sm"
          >
            {tag.tag}
          </button>
          {showDeleteButton && onDeleteTag && (
            <button
              onClick={() => handleDelete(tag.id)}
              className="ml-1 hover:text-red-500 text-sm"
              title="タグを削除"
            >
              <span className="opacity-60 hover:opacity-100">×</span>
            </button>
          )}
        </div>
      ))}
    </div>
  );
};